module.exports = __webpack_public_path__ + "img/seven.4a109eeb.png";